import { InView } from "react-intersection-observer";

import FloorMap from './FloorMap';

const MarauderMap = function({validDevices, displayNames}){
    const maps = [];

    for (let i = 6; i >= 1; i = i - 1) {
        maps.push(
            <InView
                key = {`map-v${i}`}
                threshold = {0.5}
            >
                {({ ref }) => (
                    <div ref={ref}>
                        <FloorMap
                            floorNumber = { i }
                            validDevices = { validDevices }
                            displayNames = { displayNames }
                        />
                    </div>
                )}
            </InView>
        );
    }

    return (
        <div
            className='marauder-map'
        >
            { maps }
        </div>
    );
}

export default MarauderMap;
